import fr from 'facet-rest';
import RichTextDisplay from 'Components/UI/RichTextDisplay';

const BulkCommunicationSummaryTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('messageContent', {
    _component: () => RichTextDisplay,
  });

export default BulkCommunicationSummaryTableOverride;
